module.exports = require("./ar-SO.js");